import { useCallback } from "react";
import confirm from "@app/services/confirm/confirm";
import { buildBoOperationConfirmOptions, type BuildBoOperationConfirmParams } from "./buildBoOperationConfirmOptions";
import type { PerformBoOperationVariables } from "./usePerformBoOperationMutation";

export type { PerformBoOperationVariables };

export interface ConfirmAndPerformBoOperationParams extends BuildBoOperationConfirmParams {
    boCode: number;
}

export interface UseBoOperationConfirmParams {
    /** Действие выполнения операции после подтверждения (обычно `mutation.mutateAsync`). */
    perform: (variables: PerformBoOperationVariables) => Promise<unknown>;
}

/**
 * Подтверждение и запуск выполнения BO-операции через app confirm.
 * Сама mutation orchestration живёт в screen-level `use*Mutations`.
 */
export function useBoOperationConfirm({ perform }: UseBoOperationConfirmParams) {
    const confirmAndPerform = useCallback(
        async (params: ConfirmAndPerformBoOperationParams): Promise<void> => {
            const accepted = await confirm.show(buildBoOperationConfirmOptions(params));
            if (!accepted) {
                return;
            }

            await perform({
                operationCode: params.operation.Code,
                boCode: params.boCode,
            });
        },
        [perform],
    );

    return { confirmAndPerform };
}
